export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker (1).d40f9fc3.jpg";